<template>
  <div>
    <b-checkbox v-model="isTermsAccepted" :class="{'animate__animated': true, 'animate__shakeX': isError}">
      I agree to the <a href="#" @click="showTermsModal(true)">terms and conditions</a>
    </b-checkbox>
    <portal to="global-modal-portal" v-if="isTermsModalActive">
      <b-modal :active.sync="isTermsModalActive" :width="640" scroll="keep" :has-modal-card="true" :canCancel="false">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Terms and Conditions</p>
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column has-text-left">
                <p>By clicking 'Accept/Submit', you submit and certify that all of the statements in this application are true and are made for the purpose of obtaining credit
                    and you further acknowledge having read the company's privacy policy notice.</p>
                <br><p>You authorize us to</p><br>
                <p>
                  <ul>
                    <li>
                      (i) begin a credit investigation, including obtaining your consumer credit report;
                    </li>
                    <li>
                      (ii) forward, or allow direct electronic access to your application to lenders,
                      financial institutions, or other third parties in order to process your applicaton;
                    </li>
                    <li>
                      (iii) contact you via phone, text, and email
                    </li>
                  </ul>
                </p>
                <br>
                <p>We may obtain information about you as described in the privacy policy notice. This does not apply to information obtained in a non-financial transaction.</p>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-info" @click="showTermsModal(false)">Accept</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </div>
</template>

<script>

export default {
  name: 'TermsControl',
  components: {
  },
  props: {
    currentCustomer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isTermsModalActive: false,
      instanceId: this.$uuid.v4(),
      isError: false
    }
  },
  computed: {
    // Bound directly to the prop so the checkbox state cannot desync
    // when the parent reassigns currentCustomer (e.g. fetchCustomer /
    // fetchCreditApplication spreading a fresh server response).
    isTermsAccepted: {
      get () {
        return this.currentCustomer ? !!this.currentCustomer.isCreditTermsAccepted : false
      },
      set (value) {
        if (this.currentCustomer) {
          this.currentCustomer.isCreditTermsAccepted = value
        }
      }
    }
  },
  methods: {
    showError: function () {
      this.$buefy.toast.open(
        {
          duration: 2500,
          message: 'You must accept the terms and conditions to proceed',
          position: 'is-top',
          type: 'is-warning'
        })
      this.isError = true
      window.setTimeout(() => {
        this.isError = false
      }, 1000)
    },
    showTermsModal: function (state) {
      if (state) {
        this.isTermsModalActive = true
      } else {
        this.isTermsModalActive = false
      }
    }
  },
  mounted: function () {
  }
}

</script>

<style scoped>
  .modal-card-head, .modal-card-foot {
    padding: 20px !important
  }

  .modal-card-body {
    max-height: 500px !important;
    min-height: 500px !important;
    height: 500px !important;
  }
</style>
